// LifeAtDrBhuPat.js
import React, { useEffect, useRef } from 'react';
import '../styles/LifeAtDrBhuPat.css';
import LifeAtCompany from './LifeAtCompany';

const LifeAtDrBhuPat = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    const handleError = (e) => {
      console.error('Error loading video:', e);
      if (video.parentElement) {
        video.parentElement.style.backgroundColor = '#f3f4f6';
      }
    };

    const handleLoadedData = () => {
      video.play().catch(error => {
        console.log('Auto-play was prevented:', error);
      });
    };

    video.addEventListener('error', handleError);
    video.addEventListener('loadeddata', handleLoadedData);

    return () => {
      video.removeEventListener('error', handleError);
      video.removeEventListener('loadeddata', handleLoadedData);
      video.pause();
      video.removeAttribute('src');
    };
  }, []);

  return (
    <div className="life-at-container">
      {/* <nav className="navbar">
        <a href="/" className="back-btn">
          <RiArrowLeftLine className="back-icon" />
          Back to Home
        </a> 
        <h1>Life at Dr. BhuPat Pharma</h1>
      </nav> */}

      <main className="video-container">
        <video 
          ref={videoRef}
          id="pharmaVideo" 
          autoPlay 
          loop 
          playsInline 
          muted
        >
          <source src="/assets/phrama.mp4" type="video/mp4" />
          <p>Your browser does not support the video tag.</p>
        </video>
        <div className="content-overlay">
          <h1>Welcome to Life at Dr. BhuPat Pharma</h1>
         
          <button className="cta-button">Join Our Team</button>
        </div>
      </main>
      <LifeAtCompany />
    </div>
  );
};

export default LifeAtDrBhuPat;